import { IonMenuButton } from '@ionic/react';
import styled from 'styled-components';
import { AllieColors } from '../../../../common/color.types';
import { AllieToolbar } from '../../../../components/Toolbar/Toolbar/Toolbar';
import { AllieHeader } from '../../../../components/Toolbar/Header/Header';
import { AllieButton } from '../../../../components/Buttons/Button/Button';
import { AllieImg } from '../../../../components/Media/Img/Img';
import { AllieItem } from '../../../../components/Item/Item/Item';
import { AllieCheckbox } from '../../../../components/Checkbox/Checkbox';
/* import {
  AllieButton,
  AllieCheckbox,
  AllieHeader,
  AllieImg,
  AllieItem,
  AllieToolbar,
} from '../../../../components'; */

export const InfoUserWrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: ${(props) => (props.isMobile ? '6px' : '12px')};
`;

export const StyledToolbar = styled(AllieToolbar)`
  display: flex;
  justify-content: space-between;
  --background: transparent;
  ion-button {
    --ion-toolbar-background: auto;
  }
`;

export const AllieHeaderStyled = styled(AllieHeader)<{ color?: AllieColors; isMobile?: boolean }>`
  padding: ${({ isMobile }) => (isMobile ? '0 8px 0 0' : '0 12px 0 20px')};
  height: ${({ isMobile }) => (isMobile ? '75px' : 'auto')};
  min-height: ${({ isMobile }) => (isMobile ? '75px' : 'auto')};
  background: ${({ color }) =>
    color ? `var(--allie-color-${color})` : 'var(--allie-color-neutral-10)'};
  align-items: center;
  display: flex;
  /* padding: 4px 20px; */
  box-sizing: border-box;
  border-bottom: none;
  justify-content: space-between;

  &::after {
    content: none;
  }
`;

export const HelpButton = styled(AllieButton)`
  --padding-top: 4px;
  --padding-bottom: 4px;
`;

export const HelpIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
  cursor: pointer;
  color: var(--allie-color-neutral-main);
  transition: opacity 0.2s ease;
  flex-shrink: 0;
  position: relative;

  &:hover {
    opacity: 0.7;
  }

  &:focus-visible {
    outline: 2px solid var(--allie-color-secondary-main);
    outline-offset: 2px;
    border-radius: 4px;
  }

  ion-icon,
  svg {
    width: 24px;
    height: 24px;
    font-size: 24px;
  }
`;

export const HeaderButtonDesktop = styled(AllieButton)`
  --border-width: 1px;
  --border-color: var(--allie-color-neutral-30);
  --box-shadow: var(--allie-shadow-xs);
  --background: var(--allie-color-white);
  --padding-start: 14px;
  --padding-end: 14px;
`;

export const ContentHeaderButton = styled.div`
  display: flex;
  align-items: center;
  column-gap: var(--allie-spacing-sm);

  ion-icon {
    font-size: 20px;
  }
`;

export const StyledToggleMenuButton = styled(IonMenuButton as any)<{ hasNotification?: boolean }>`
  --padding-start: 10px;
  --padding-end: 10px;
  border: 1px solid var(--allie-color-menu-arrow);
  border-radius: var(--allie-spacing-md);
  margin-right: var(--allie-spacing-lg);

  ${(props) =>
    props.hasNotification &&
    `
    &::after {
      content: '';
      position: absolute;
      top: 10px;
      right: 18px;
      width: 10px;
      height: 10px;
      background-color: var(--allie-color-error-main);
      border-radius: 50%;
    }
  `}
`;

export const StyledLogoContainer = styled.div`
  display: flex;
  gap: var(--allie-radius-md);
  align-items: center;
  overflow: hidden;
`;

export const StyledAllieImg = styled(AllieImg)`
  &::part(image) {
    width: 32px;
  }
`;

export const UserMenuItem = styled(AllieItem)<{ isLast: boolean }>`
  margin-right: 10px;
  ${({ isLast }) => (isLast ? 'border-top: solid var(--allie-color-light-70);' : '')}
`;

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
  color: var(--allie-color-primary-90);
`;

export const LanguageContainer = styled.div`
  padding: 8px 16px 12px;
`;

export const LanguageOption = styled(AllieCheckbox)`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const StyledItem = styled(AllieItem)`
  --padding-start: 0;
  --padding-end: 0;
  --inner-padding-end: 0;
  --background-hover: transparent;
  height: 40px;
`;
